import "./App.css";
import "./i18nextConf";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Navbar from "./componant/Navbar";
import Footer from "./componant/Footer";
import Home from "./page/Home";
import Login from "./page/Login";
import Setup from "./page/Setup";
import Show from "./page/Show";
import Stats from "./page/Stats";
import Qrgen from "./page/Qrgen";
import About from "./page/About";
import Contact from "./page/Contact";

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ReactGA from "react-ga";

function App({ props }) {
  const location = useLocation().pathname;
  const [dir, setdir] = useState("ltr");
  const lang = localStorage.getItem("lang");

  useEffect(() => {
    ReactGA.initialize("UA-239858558-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    setdir(localStorage.getItem("lang") === "en" ? "ltr" : "rtl");
  }, [dir]);

  // Mirror the class on <html> so modals and alerts rendered in portals use the font too.
  const useRabar = lang === "ku" || lang === "ar";
  useEffect(() => {
    document.documentElement.classList.toggle("font-face-gm", useRabar);
  }, [useRabar]);

  const isEnRoute = location.startsWith("/en");

  return (
    <div className={useRabar ? "font-face-gm" : ""} dir={dir}>
      {isEnRoute ? <Navbar /> : <></>}
      <Routes>
        <Route path="/en/home" element={<Home />}></Route>
        <Route path="/en/Login" element={<Login />}></Route>
        <Route path="/en/Setup" element={<Setup />}></Route>
        <Route path="/en/Show" element={<Show />}></Route>
        <Route path="/en/stats" element={<Stats />} />
        <Route path="/en/qrgenrater" element={<Qrgen />} />
        <Route path="/en/about" element={<About />} />
        <Route path="/en/contact" element={<Contact />} />

        <Route path="/:user" element={<Show />}></Route>
        <Route path="*" element={<Navigate replace to="/en/home" />} />
      </Routes>
      {isEnRoute ? <Footer /> : <></>}
    </div>
  );
}

export default App;
